import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_ENTITIES_REQUEST,
    getEntitiesSuccess,
    getEntitiesFailure,

    GET_ENTITY_REQUEST,
    getEntitySuccess,
    getEntityFailure,

    CREATE_ENTITY_REQUEST,
    createEntitySuccess,
    createEntityFailure,

    UPDATE_ENTITY_REQUEST,
    updateEntitySuccess,
    updateEntityFailure,

    DELETE_ENTITY_REQUEST,
    deleteEntitySuccess,
    deleteEntityFailure,

    GET_ARTISTS_REQUEST,
    getArtistsSuccess,
    getArtistsFailure,

    GET_ENTITY_GLOBALS_REQUEST,
    getEntityGlobalsSuccess,
    getEntityGlobalsFailure,
    CLEAR_ENTITY_DATA,
} from "../actions/getEntity";

function* getEntitiesSaga(action) {
    try {
        const page = action?.payload?.page || 1;
        const limit = action?.payload?.limit || 10;
        const displayName = action?.payload?.displayName || '';
        const type = action?.payload?.type || '';
        const language = action?.payload?.language || '';
        const country = action?.payload?.country || '';
        const year = action?.payload?.year || '';
        const response = yield call(api_service.getEntities, page, limit, displayName, type, language, country, year);
        yield put(getEntitiesSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getEntitiesFailure(err?.message || 'Network error'));
        } else {
            yield put(getEntitiesFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* getEntitySaga(action) {
    try {
        const response = yield call(api_service.getEntity, action?.payload);
        yield put(getEntitySuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getEntityFailure(err?.message || 'Network error'));
        } else {
            yield put(getEntityFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* getEntityGlobalsSaga(action) {
    try {
        const response = yield call(api_service.getEntityGlobals, action?.payload);
        if (response?.error) {
            yield put(getEntityGlobalsFailure(response?.error));
        }
        else {
            yield put(getEntityGlobalsSuccess(response));
        }
    } catch (err) {
        console.log("err => ", err)
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getEntityGlobalsFailure(err?.message || 'Network error'));
        } else {
            yield put(getEntityGlobalsFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* createEntitySaga(action) {
    try {
        const response = yield call(api_service.createEntity, action.payload);
        yield put(createEntitySuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(createEntityFailure(err?.message || 'Network error'));
        } else {
            yield put(createEntityFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* updateEntitySaga(action) {
    try {
        const response = yield call(api_service.updateEntity, action?.payload);
        yield put(updateEntitySuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(updateEntityFailure(err?.message || 'Network error'));
        } else {
            yield put(updateEntityFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* deleteEntitySaga(action) {
    try {
        console.log("_id => ", action)
        const response = yield call(api_service.deleteEntity, action?.payload);
        yield put(deleteEntitySuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(deleteEntityFailure(err?.message || 'Network error'));
        } else {
            yield put(deleteEntityFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}

function* getArtistsSaga(action) {
    try {
        console.log("getArtistsSaga : ", action?.payload)
        const params = { show: 'all', type: 'artist' }
        const response = yield call(api_service.getArtists, action?.payload);
        yield put(getArtistsSuccess(response));
    } catch (err) {
        if (
            err?.code === 'ERR_NETWORK' ||
            err?.code === 'ERR_BAD_REQUEST' ||
            err?.code === 'ECONNABORTED'
        ) {
            yield put(getArtistsFailure(err?.message || 'Network error'));
        } else {
            yield put(getArtistsFailure(err?.response?.data?.message || 'Unknown error'));
        }
    }
}


function* clearEntityDataSaga() {
  yield put({ type: CLEAR_ENTITY_DATA });
}

export default function* watchGetEntitySaga() {
    yield all([
        takeEvery(GET_ENTITIES_REQUEST, getEntitiesSaga),
        takeEvery(GET_ENTITY_REQUEST, getEntitySaga),
        takeLatest(CREATE_ENTITY_REQUEST, createEntitySaga),
        takeLatest(UPDATE_ENTITY_REQUEST, updateEntitySaga),
        takeLatest(DELETE_ENTITY_REQUEST, deleteEntitySaga),
        takeEvery(GET_ARTISTS_REQUEST, getArtistsSaga),
        takeEvery(GET_ENTITY_GLOBALS_REQUEST, getEntityGlobalsSaga),
        takeEvery(CLEAR_ENTITY_DATA, clearEntityDataSaga),
    ]);
}